import React from "react";

import { isOauthCallback } from "Intuit/isIntuit";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import AnalyticsTracking from "Utils/AnalyticsTracking";
import partnerIframeCheck from "Utils/partnerIframeCheck";

import { requestInitialData, requestPlanSuite } from "./Actions";
import App from "./App";
import store from "./Store";

partnerIframeCheck();

document.addEventListener("DOMContentLoaded", () => {
  const quotePageStore = store();
  quotePageStore.dispatch(requestInitialData());
  // If we are coming from the QuickBooks oauth flow let's change the url
  // to make the QuotePage behave normally.
  if (isOauthCallback()) {
    quotePageStore.dispatch(requestPlanSuite());
  }
  AnalyticsTracking.trackEvent("google_conversion");

  const newQuotePageApp = (
    <Provider store={quotePageStore}>
      <App />
    </Provider>
  );

  const container = document.getElementById("root");
  const root = createRoot(container);
  root.render(newQuotePageApp);
});
